/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionCondition, { SpecificLinkOption } from 'cio/app-models/conditions/action';
import { MessagingChannelType } from 'cio/utils/setup-guide/messaging-channels';
import { computed } from '@ember/object';

interface SpecificLinkArgs {
  condition: ActionCondition;
  disabled: boolean;
  size: string;
  variation: string;
  fluid: boolean;
}

export default class SpecificLink extends Component<SpecificLinkArgs> {
  @computed('args.condition.{specificLink,isAnyInParent,type}', 'args.variation')
  get specificLinkOptions() {
    let { type, isAnyInParent } = this.args.condition;
    let allowedTypes = [MessagingChannelType.InApp, MessagingChannelType.Email];

    let anyOptionLabel = type === MessagingChannelType.InApp ? 'on any response' : 'on any tracked link';
    let containingOptionLabel =
      type === MessagingChannelType.InApp ? 'on response containing' : 'on tracked link containing';
    let equalOptionLabel = type === MessagingChannelType.InApp ? 'on response equal to' : 'on tracked link equal to';

    let options = [{ value: SpecificLinkOption.None, label: anyOptionLabel }];

    // sidebar and in_app -> used in wait until & we allow isAnyInParent as it utilizes foreign events
    if (this.args.variation === 'compact' && allowedTypes.includes(type as MessagingChannelType)) {
      options = [
        ...options,
        { value: SpecificLinkOption.Contains, label: containingOptionLabel },
        { value: SpecificLinkOption.Exact, label: equalOptionLabel },
      ];
    } else {
      if (!isAnyInParent) {
        options = [...options, { value: SpecificLinkOption.Contains, label: containingOptionLabel }];
      } else {
        this.args.condition.set('specificLink', SpecificLinkOption.None);
      }
    }
    return options;
  }
}
